import { getAnalytics, logEvent } from 'firebase/analytics'
import analyticsEventsName from './analyticsEventName'
const analytics = getAnalytics()

export const callAnalyticsEvent = (name, MSSISDN, specialEventParam = {}) => {
  logEvent(analytics, analyticsEventsName[name], {
    PLATFORM: 'Website',
    TIMESTAMP: new Date().getTime(),
    MSSISDN: MSSISDN,
    ...specialEventParam,
  })
}
